// extracted by mini-css-extract-plugin
export default {"space":"Space_space__jCUkO","buttons":"Space_buttons__Ffvj4","button":"Space_button__UIBer"};